import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/design/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_app/design/"!</div>
}
